/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOrderingProfileLocationsRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetOrderingProfileLocationsResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getOrderingProfileLocations = (request: GetOrderingProfileLocationsRequest, options?: CashRequestOptions) => post<GetOrderingProfileLocationsRequest, GetOrderingProfileLocationsResponse>("/2.0/cash/get-ordering-profile-locations", request, {...options, rejectOnError: true })